import * as InsuranceModalConfirmINN from './components/InsuranceModalConfirmINN.css';
export default {
    InsuranceModalConfirmINN
};
